import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  textField: {
    '& .MuiInputBase-input': {
      height: '20px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#006E90',
    },
    '& .MuiInputLabel-root': {
      color: '#006E90',
    },
  },
}));

export default useStyles;
